import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';

export class PatientService extends BaseService {
  static async getPatients(nextpage) {
    try {
      const response = await this.request({ auth: true }).get(
        `patient?nextpage=${nextpage}`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getPatient(patientId) {
    try {
      const response = await this.request({ auth: true }).get(
        `patient/${patientId}`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getIncomingPatients(nextpage) {
    try {
      const response = await this.request({ auth: true }).get(
        `patient/incoming?nextpage=${nextpage}`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async acceptPatient(patientId) {
    try {
      const response = await this.request({ auth: true }).put(
        `patient/${patientId}/accept`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getVerification() {
    try {
      const response = await this.request({ auth: true }).get(
        'patient/verification'
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getHealthQuestions() {
    try {
      const response = await this.request({ auth: true }).get(
        '/patient/healthquestion'
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async saveHealthQuestions(data) {
    try {
      const response = await this.request({ auth: true }).put(
        '/patient/healthquestion',
        data
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getHSAReceipt(id, year = null) {
    let url;
    if (year) {
      url = `/hsaReceipt/${id}/${year}`;
    } else {
      url = `/hsaReceipt/${id}/`;
    }
    try {
      const response = await this.request({ auth: true }, 'v2').get(url);
      return response;
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFSAReceipt(id, year) {
    try {
      const url = year ? `/fsaReceipt/${id}/${year}` : `/fsaReceipt/${id}`;
      const response = await this.request({ auth: true }, 'v2').get(url);
      return response;
      // return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getNDCForm(id, year) {
    try {
      const url = year ? `/ndc/${id}/${year}` : `/ndc/${id}`;
      const response = await this.request({ auth: true }, 'v2').get(url);
      return response;
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getStripeSetupIntentClientSecret() {
    try {
      const response = await this.request({ auth: true }).post(
        '/payment/setup-intent-client-secret'
      );
      return response;
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getMedicalNecessityLetter(id) {
    try {
      const response = await this.request({ auth: true }, 'v2').get(
        `medicalLetter/${id}`
      );
      return response;
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getMedicalRecords(id) {
    try {
      const response = await this.request({ auth: true }, 'v2').get(
        `/medicalRecords/${id}`
      );
      return response;
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getPatientFollowUpCheck() {
    try {
      const response = await this.request({ auth: true }, 'v2').get(
        'patient/followup/check'
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async patientApplyCoupon(followUpId, data) {
    try {
      const response = await this.request({ auth: true }, 'v2').post(
        `patient/followup/${followUpId}/applyCoupon `,
        { ...data }
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const errorMessage = error.response?.data || 'Something went wrong';
      throw new ErrorWrapper(error, errorMessage);
    }
  }

  static async patientClaimCoupon(followUpId, data) {
    try {
      const response = await this.request({ auth: true }, 'v2').post(
        `patient/followup/${followUpId}/claim `,
        { ...data }
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const errorMessage = error.response?.data || 'Something went wrong';
      throw new ErrorWrapper(error, errorMessage);
    }
  }
}
